export default __webpack_public_path__ + "static/media/good.5bb118a4.mp3";